// +----------------------------------------------------------------------
// | 公共函数方法
// +----------------------------------------------------------------------
// | Copyright (c) 2018 安徽秒速科技有限公司 All rights reserved.
// +----------------------------------------------------------------------
// | Author：tangfei <957987132@qq.com>
// +----------------------------------------------------------------------

import Vue from "vue";
import Axios from "axios";
import Cookies from "js-cookie";
import hex_md5 from "md5";
import router from "../../router";
import appConfig from "@/config/app"; //引入配置文件
import $$ from "jquery";

//是否开启ajax debug模式
const ajax_debug = appConfig.ajax_debug;
//是否开发者模式
const devMode = appConfig.devMode;
//是否使用jsonp 如果开发者模式启用，强制不使用jsonp
const jsonpMode = appConfig.devMode ? false : appConfig.jsonpMode;
//接口地址
let hostName = appConfig.devMode ? appConfig.ajaxApi.devHostName : appConfig.ajaxApi.hostName;
const func = {

    //图片域名
    imgSrc: appConfig.imgSrc,

    //设置页面 title
    title: (title = "首页") => {
        window.document.title = title;
    },

    jumps(name){
        router.push({name: name})
    },

    /*
     将开关数组转成十进制指令
     len是8或32
     command如果是全部开启或关闭，直接传all，否则就传数组，数组顺序无所谓
     返回：字符串格式的数字指令
     command 开关
     */
    enTransformCode(len, command){
        var str = '', arrStr = '';
        switch (len) {
            case 8:
                if (command === 'off') {
                    return '0'
                } else if (command === 'on') {
                    return '255'
                } else {
                    arrStr = command.join();
                    for (let i = 8; i >= 1; i--) {
                        if (arrStr.indexOf(i) > -1) {
                            str += '1';
                        } else {
                            str += '0';
                        }
                    }
                    return '' + parseInt(str, 2);
                }
            case 32:
                if (command === 'off') {
                    return '0,0,0,0';
                } else if (command === 'on') {
                    return '255,255,255,255';
                } else {
                    command.reverse();
                    for (let i = 32; i >= 1; i--) {
                        if (command.indexOf(i) > -1) {
                            str += '1';
                        } else {
                            str += '0';
                        }
                    }
                    var str2 = '';
                    for (let j = 0; j < 32; j += 8) {
                        str2 += str.substr(j, 8)
                        if (j !== 24) {
                            str2 += ',';
                        }
                    }
                    var arr2 = str2.split(',');
                    var str3 = '';
                    arr2.map(function (item, index) {
                        str3 += parseInt(item, 2)
                        if (index != arr2.length - 1) {
                            str3 += ','
                        }
                    })
                    return str3
                }
            default:
                break;
        }
    },

    /*
     将十进制指令转成开关数组
     len是8或32,command是一个正整数，可以是字符串也可以是数字
     返回：数组格式的开关编号
     command 指令
     */
    deTransformCode(len, command){
        var numArr = [], str = '';
        if (len === 8) {
            numArr.push(command);
        } else if (len === 32) {
            numArr = command.split(',');   //[15,2,3,10]
        } else if (len === 16) {
            numArr = command.split(',');   //[15, 10]
        }
        numArr.map(function (item, index) {
            item = parseInt(item);
            var temp = [];
            var temp2 = '';
            for (let i = 0; i >= 0; i++) {
                if (item / 2 >= 1) {
                    temp.push(item % 2);
                    item = parseInt(item / 2);
                } else {
                    temp.push(item);
                    break;
                }
            }
            for (let i = temp.length; i > 0; i--) {
                temp2 += '' + temp[i - 1];
            }
            //补零
            for (var j = 1; j <= 8 - temp.length; j++) {
                temp2 = '0' + temp2;
            }
            str += temp2;
        })

        var arr2 = str.split('');
        arr2 = arr2.reverse();
        var arr3 = [];
        arr2.map(function (item, index) {
            if (item == 1) {
                arr3.push(index + 1)
            }
        })
        return arr3;
    },

    //截取晶控开关指令中间
    getJkSwitchOrder: function (result) {
        if (result) {
            var str = result;
            var arr = str.split(',');
            var str2 = '';
            for (var i = 0; i < arr.length; i++) {
                if (i == 0 || i == arr.length - 1) {
                    continue;
                }
                str2 += arr[i] + ','
            }
            str2 = str2.substr(0, str2.length - 1);
            return str2;
        }
    },


    //zero
    addZero: function (n) {
        var ret = null;
        ret = n > 9 ? ('' + n) : ('0' + n);
        return ret;
    },

    //去重 params 为对象中的参数，如var arr = [{name:张飞},{name:张飞},{name:李飞}]； 那么unique('name',arr); 最后结果[{name:张飞},{name:李飞}]
    uniqueArr(params, arr) {
        let obj = {}
        arr = arr.reduce((item, next) => {
            obj[next[params]] ? '' : obj[next[params]] = true && item.push(next)
            return item
        }, [])
        return arr;
    },

    // 验证手机号
    checkphone: function (str) {
        if (str) {
            if (str.match(/^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[1-9])[0-9]{8}$/)) {
                return true;
            } else {
                return false;
            }
        }
    },

    //验证密码 - 密码字数限制（6-16位英文，数字。可混组）
    checkPassword: function (s) {
        var regu = /^[a-zA-Z0-9]{6,16}$/;
        var re = new RegExp(regu);
        if (re.test(s)) {
            return true;
        } else {
            return false;
        }
    },

    //去除首尾空格
    trim: function (obj) {
        if (typeof obj === 'string') {
            return obj.replace(/^\s+|\s+$/gm, '');
        } else {
            return obj
        }
    },

    //萤石视频
    ys: {
        api: devMode ? '' : appConfig.thirdApi.ys,

        //获取token
        getYsToken(fn){
            func.ajax('videoAccessToken', {
                token: func.getToken()
            }, function (r) {
                if (!r.statusCode) {
                    func.msg(r.message, 'error');
                } else {
                    //存储登录数据
                    func.data.set("videoAccessToken", r.type.data.accessToken);
                    if (typeof fn == "function") fn(r);
                }
            })
        },

        //获取单个设备信息 status	int	在线状态：0-不在线，1-在线
        getDevideInfo(serial, fn, fn2)
        {
            let that = this;
            if (func.data.get('videoAccessToken') != undefined) {
                func.axiosRequest(that.api + 'lapp/device/info', {
                    accessToken: func.data.get('videoAccessToken'),
                    deviceSerial: serial
                }, function (response) {
                    if (typeof fn == "function") fn(response);
                }, function (response) {
                    if (typeof fn2 == "function") fn2(response);
                }, '', 'post', '', function (response) {
                    if (typeof fn2 == "function") fn2(response);
                    // func.notice('萤石【获取某个设备的信息】链接失败，请联系管理员！', 'error', '系统提示');
                }, false, false)
            } else {
                if (ajax_debug) console.log(`%c 萤石【获取某个设备的信息】链接失败，请联系管理员! %c`, "color:red; font-weight:bold", "", "")
            }
        },

        // 获取某个设备直播地址
        getDevideAddress(serial, fn)
        {
            let that = this;
            if (func.data.get('videoAccessToken') != undefined) {
                func.axiosRequest(that.api + 'lapp/live/address/limited', {
                    accessToken: func.data.get('videoAccessToken'),
                    deviceSerial: serial,
                    channelNo: 1, //int	通道号，IPC设备填1
                }, function (response) {
                    if (typeof fn == "function") fn(response);
                }, '', '', 'post', '', function () {
                    // func.notice('萤石【获取某个设备的信息】链接失败，请联系管理员！', 'error', '系统提示');
                }, false, false)
            } else {
                if (ajax_debug) console.log(`%c 萤石【获取某个设备的信息】链接失败，请联系管理员! %c`, "color:red; font-weight:bold", "", "")
            }
        },

        //开始控制云台
        controllDevice(index, serial, fn, fn2, fn3)
        {
            let that = this;
            if (func.data.get('videoAccessToken') != undefined) {
                func.axiosRequest(that.api + 'lapp/device/ptz/start', {
                    accessToken: func.data.get('videoAccessToken'),
                    deviceSerial: serial,
                    channelNo: 1, //int	通道号，IPC设备填1
                    direction: index,
                    speed: 1
                }, function (response) {
                    if (response.code == 200) {
                        Vue.prototype.$Message.loading({
                            content: '指令发送成功，正在执行...',
                            duration: 0
                        });

                        //1秒后停止设备
                        setTimeout(function () {
                            func.axiosRequest(that.api + 'lapp/device/ptz/stop', {
                                accessToken: func.data.get('videoAccessToken'),
                                deviceSerial: serial,
                                channelNo: 1, //int	通道号，IPC设备填1
                                direction: index
                            }, function (response2) {
                                if (response2.code == 200) {
                                    setTimeout(function () {
                                        Vue.prototype.$Message.destroy();
                                        func.msg('操作成功');
                                        if (typeof fn == "function") fn(response);
                                    }, 1000)
                                } else {
                                    func.msg(response2.msg, 'error');
                                    if (typeof fn2 == "function") fn2(response);
                                }
                            }, '', '', 'post', '', function () {
                                if (typeof fn2 == "function") fn2(response);
                                // func.notice('萤石【获取某个设备的信息】链接失败，请联系管理员！', 'error', '系统提示');
                            }, false, false)
                        }, 1000)

                    } else {
                        func.msg(response.msg, 'error');
                        if (typeof fn2 == "function") fn2(response);
                    }
                }, '', '', 'post', '', function () {
                    if (typeof fn3 == "function") fn3();
                    // func.notice('萤石【获取某个设备的信息】链接失败，请联系管理员！', 'error', '系统提示');
                }, false, false)
            } else {
                if (ajax_debug) console.log(`%c 萤石【获取某个设备的信息】链接失败，请联系管理员! %c`, "color:red; font-weight:bold", "", "")
            }
        },
    },
    jx: {
//查询采集器的单个节点
        selSingleSensorData(deviceNumber, eid, succFun, failFunc){
            var wire = eid.split('-')[2];
            func.ajax('selSingleSensorData', {
                deviceNumber: deviceNumber,
                wire: wire
            }, function (res) {
                if (res.state == 'success') {
                    res.eqmsg = func.sensorData(eid, 5)[0];
                    res.eqmsg.value = res.data.value,
                        succFun(res)
                } else {
                    failFunc(res.msg)
                }
            }, function () {
                failFunc('失败')
            }, 'post', true, function () {
                failFunc('失败')
            })
        },
        /**
         * 功能描述: 顺带判断 继电器/传感器工作是否正常 是否为开（继电器只有有一个开即为开）
         */
        getDeviceInfo(deviceNumber, eid, succFunc, failFunc){
            func.ajax('getDeviceInfo', {
                deviceNumber: deviceNumber
            }, function (res) {
                if (res.state == 'success') {
                    res.broken = false;
                    //继电器是否开
                    res.isOpen = false;
                    res.stateArr = [];
                    // 离线就必定关？
                    if (res.data.onLineState == 0) {//离线
                        res.broken = true;
                        res.isOpen = false;
                    } else {
                        // 继电器只有有一个开即为开
                        if (func.isRelay(eid)) {
                            var switchArr = res.data.data.replace(/\s*/g, "").split('|');
                            switchArr.map(function (item) {
                                res.isOpen = res.isOpen || item == '开';
                                res.stateArr.push(item == '开');
                            })
                        } else {
                            res.isOpen = true;
                        }
                    }

                } else {
                    res.broken = true;
                    res.isOpen = false;
                }
                console.log(res);
                succFunc(res)
            }, function () {
                failFunc('失败')
            }, 'post', true, function () {
                failFunc('失败')
            })

        },
        /**
         * 功能描述: 关闭/开启单路 继电器
         */
        onOffRelay(deviceNumber, wire, isOpen){
            func.ajax('onOffRelay', {
                deviceNumber: deviceNumber,
                wire: wire,
                isOpen: isOpen
            }, function (res) {
                if (res.state == 'success') {
                    func.msg(res.msg);
                } else {
                    func.msg(res.msg, 'error');
                }
            }, function () {
                func.msg('失败')
            }, 'post', true, function () {
                func.msg('失败')
            })
        },
        // 2019-08-02 zby 9.获取某一设备的历史记录（数据统计）
        getSensorEqls(deviceNumber, startTime, endTime, fn, fn2)
        {
            let that = this;
            func.ajax('selHistoryForDate', {
                deviceNumber: deviceNumber,
                page: 1,
                size: 500,
                startTime: startTime + ' 00:00:00',
                endTime: endTime + ' 00:00:00'
            }, function (res) {
                if (res.state == 'success') {
                    var resArr = [];
                    //数组逆序
                    for (var i = res.datas.length - 1; i >= 0; i--) {
                        resArr.push(res.datas[i]);
                    }
                    fn(resArr)
                } else {
                    func.msg(res.msg, 'error');
                }
            }, function () {
                func.msg('失败')
            }, 'post', true, function () {
                func.msg('失败')
            })
        },
    },

    //jsonp请求
    jsonpAjax(url, data, fn, fn2)
    {
        $$.ajax({
            url: url,
            type: 'GET',
            data: data,
            timeout: 10000,
            dataType: 'jsonp',
            jsonp: 'callback',
            success: function (response) {
                if (typeof fn == "function") fn(response);
            }, error: function (xhr, textStatus) {
                if (typeof fn2 == "function") fn2(xhr, textStatus);
            }
        });
    },

    //获取天正设备信息
    tz: {
        api: devMode ? '' : appConfig.thirdApi.tz,

        //登录后获取天正key
        getTokey(fn, fn2)
        {
            let token = func.getToken();
            if (token) {
                func.ajax('tokey',
                    {
                        token: token,
                    }, function (r) {
                        if (!r.statusCode) {
                            func.msg(r.message, 'error');
                        } else {
                            //存储登录数据
                            func.data.set("tzuid", r.type.id);
                            func.data.set("tztokey", r.type.msg);
                            if (typeof fn == "function") fn(r);
                        }
                    }, function () {
                        if (typeof fn2 == "function") fn2();
                    }, 'post', 'true', function () {
                        if (typeof fn2 == "function") fn2();
                        // func.notice('天正token获取失败，请联系管理员！', 'error', '系统提示');
                    })
            } else {
                if (ajax_debug) console.log(`%c 天正token获取失败，请联系管理员！ %c`, "color:red; font-weight:bold", "", "")
            }
        },

        // 获取某个设备的信息
        getDevideInfo(emac, fn, fn2)
        {
            let that = this;
            if (func.data.get('tzuid') != undefined && func.data.get('tztokey') != undefined) {
                //判断是否使用jsonp
                if (jsonpMode) {
                    func.jsonpAjax(that.api + 'API/App/eqinfo', {
                        uid: func.data.get('tzuid'),
                        tokey: func.data.get('tztokey'),
                        emac: emac
                    }, function (response) {
                        if (typeof fn == "function") fn(response);
                    }, function (xhr, textStatus) {
                        if (typeof fn2 == "function") fn2(xhr, textStatus);
                    })
                } else {
                    func.axiosRequest(that.api + 'API/App/eqinfo', {
                        uid: func.data.get('tzuid'),
                        tokey: func.data.get('tztokey'),
                        emac: emac
                    }, function (response) {
                        if (typeof fn == "function") fn(response);
                    }, function () {
                        if (typeof fn2 == "function") fn2();
                    }, '', 'get', '天正-获取某个设备的信息', function () {
                        if (typeof fn2 == "function") fn2();
                        // func.notice('天正【获取某个设备的信息】链接失败，请联系管理员！', 'error', '系统提示');
                    })
                }
            } else {
                if (ajax_debug) console.log(`%c 天正【获取某个设备的信息】链接失败，请联系管理员! %c`, "color:red; font-weight:bold", "", "")
            }
        },

        // 获取设备预警消息列表
        getDevideNotice(fn, fn2)
        {
            let that = this;
            if (func.data.get('tzuid') != undefined && func.data.get('tztokey') != undefined) {
                //判断是否使用jsonp
                if (jsonpMode) {
                    func.jsonpAjax(that.api + 'API/App/notice', {
                        uid: func.data.get('tzuid'),
                        tokey: func.data.get('tztokey')
                    }, function (response) {
                        if (typeof fn == "function") fn(response);
                    }, function (xhr, textStatus) {
                        if (typeof fn2 == "function") fn2(xhr, textStatus);
                    })
                } else {
                    func.axiosRequest(that.api + 'API/App/notice', {
                        uid: func.data.get('tzuid'),
                        tokey: func.data.get('tztokey')
                    }, function (response) {
                        if (typeof fn == "function") fn(response);
                    }, function () {
                        if (typeof fn2 == "function") fn2();
                    }, '', 'get', '天正-获取设备预警消息列表', function () {
                        if (typeof fn2 == "function") fn2();
                        // func.notice('天正【获取设备预警消息列表】链接失败，请联系管理员！', 'error', '系统提示');
                    }, false)
                }
            } else {
                if (ajax_debug) console.log(`%c 天正【获取设备预警消息列表】链接失败，请联系管理员! %c`, "color:red; font-weight:bold", "", "")
            }
        },

        // 操作设备
        setDevideSwitch(res, fn, fn2)
        {
            let that = this;
            if (func.data.get('tzuid') != undefined && func.data.get('tztokey') != undefined) {
                //判断是否使用jsonp
                if (jsonpMode) {
                    func.jsonpAjax(that.api + 'API/control/offon', {
                        uid: func.data.get('tzuid'),     //返回的用户 ID
                        tokey: func.data.get('tztokey'), //返回的 msg
                        EMac: res.EMac,//设备 mac
                        GMac: res.GMac,//网关 mac
                        Instructions: res.Instructions,//控制指令
                        Msg: res.Msg //发送消息指令（设备指令）
                    }, function (response) {
                        if (typeof fn == "function") fn(response);
                    }, function (xhr, textStatus) {
                        if (typeof fn2 == "function") fn2(xhr, textStatus);
                    })
                } else {
                    func.axiosRequest(that.api + 'API/control/offon', {
                        uid: func.data.get('tzuid'),     //返回的用户 ID
                        tokey: func.data.get('tztokey'), //返回的 msg
                        EMac: res.EMac,//设备 mac
                        GMac: res.GMac,//网关 mac
                        Instructions: res.Instructions,//控制指令
                        Msg: res.Msg //发送消息指令（设备指令）
                    }, function (response) {
                        if (typeof fn == "function") fn(response);
                    }, function () {
                        if (typeof fn2 == "function") fn2();
                    }, '', 'get', '天正-操作设备', function () {
                        if (typeof fn2 == "function") fn2();
                        // func.notice('天正【操作设备】链接失败，请联系管理员！', 'error', '系统提示');
                    }, false)
                }
            } else {
                if (ajax_debug) console.log(`%c 天正【操作设备】链接失败，请联系管理员! %c`, "color:red; font-weight:bold", "", "")
            }
        },

        // 获取所有设备列表
        checkEquipment(fn, fn2)
        {
            let that = this;
            if (func.data.get('tzuid') != undefined && func.data.get('tztokey') != undefined) {
                //判断是否使用jsonp
                if (jsonpMode) {
                    func.jsonpAjax(that.api + 'API/App/checkEquipment', {
                        uid: func.data.get('tzuid'),     //返回的用户 ID
                        tokey: func.data.get('tztokey'), //返回的 msg
                    }, function (response) {
                        if (typeof fn == "function") fn(response);
                    }, function (xhr, textStatus) {
                        if (typeof fn2 == "function") fn2(xhr, textStatus);
                    })
                } else {
                    func.axiosRequest(that.api + 'API/App/checkEquipment', {
                        uid: func.data.get('tzuid'),     //返回的用户 ID
                        tokey: func.data.get('tztokey'), //返回的 msg
                    }, function (response) {
                        if (typeof fn == "function") fn(response);
                    }, function () {
                        if (typeof fn2 == "function") fn2();
                    }, '', 'get', '天正-获取所有设备列表', function () {
                        if (typeof fn2 == "function") fn2();
                        // func.notice('天正【获取所有设备列表】链接失败，请联系管理员！', 'error', '系统提示');
                    }, false)
                }
            } else {
                if (ajax_debug) console.log(`%c 天正【获取所有设备列表】链接失败，请联系管理员! %c`, "color:red; font-weight:bold", "", "")
            }
        },
        // 2019-05-16 zby 9.获取某一设备的历史记录（数据统计）
        getDevideEqls(emac, bigdate, enDate, fn, fn2)
        {
            let that = this;
            if (func.data.get('tzuid') != undefined && func.data.get('tztokey') != undefined) {
                console.log(emac);
                console.log(bigdate);
                console.log(enDate);
                //判断是否使用jsonp
                if (jsonpMode) {
                    func.jsonpAjax(that.api + 'API/App/eqls', {
                        uid: func.data.get('tzuid'),
                        tokey: func.data.get('tztokey'),
                        bigdate: bigdate,
                        enDate: enDate,
                        emac: emac
                    }, function (response) {
                        if (typeof fn == "function") fn(response);
                    }, function (xhr, textStatus) {
                        if (typeof fn2 == "function") fn2(xhr, textStatus);
                    })
                } else {
                    func.axiosRequest(that.api + 'API/App/eqls', {
                        uid: func.data.get('tzuid'),
                        tokey: func.data.get('tztokey'),
                        bigdate: bigdate,
                        enDate: enDate,
                        emac: emac
                    }, function (response) {
                        if (typeof fn == "function") fn(response);
                    }, function () {
                        if (typeof fn2 == "function") fn2();
                    }, '', 'get', '天正-获取某一设备的历史记录', function () {
                        if (typeof fn2 == "function") fn2();
                        // func.notice('天正【获取某一设备的历史记录】链接失败，请联系管理员！', 'error', '系统提示');
                    })
                }
            } else {
                if (ajax_debug) console.log(`%c 天正【获取某一设备的历史记录】链接失败，请联系管理员! %c`, "color:red; font-weight:bold", "", "")
            }
        },

    },

    //退出登录
    loginOut(tips)
    {
        func.ajax('doLoginOut', {
            token: func.getToken(),
        }, function (r) {
            console.log(r);
            // if(!r.statusCode){
            //   // func.msg(r.message,'error');
            // }else{
            func.data.del("userInfo");
            func.data.del("tzuid");
            func.data.del("tztokey");
            if (tips) func.msg("退出成功");
            //跳转
            func.dsqOut(function () {
                router.push({
                    name: "login"
                });
            }, 1);
            // }
        })
    },
    isRelay(eid) {
        return eid.indexOf('relay') != -1;
    },
    isSensor(eid) {
        return eid.indexOf('sensor') != -1;
    },
    getSensorText(eid) {
        var type;
        if (eid.split('-').length > 1) {
            type = eid.split('-')[1];
        } else {
            type = eid;
        }
        var sensor;
        switch (type) {
            case 'sw':
                sensor = {'name': '水位', 'value': '', 'union': 'M', 'index': 0};
                break;
            case 'hw':
                sensor = {'name': '红外', 'value': '', 'union': '', 'index': 0};
                break;
            case 'gzd':
                sensor = {'name': '光照度', 'value': '', 'union': 'Lux', 'index': 0};
                break;
            case 'zs':
                sensor = {'name': '噪声', 'value': '', 'union': 'dB', 'index': 0};
                break;
            case 'ws':
            case 'dpws':
            case 'trws':
                sensor = {"name": "湿度", "value": '', 'union': '%RH', 'index': 1};
                break;
            case 'pm2510':
                sensor = {"name": "PM2.5", "value": '', 'union': 'ug/m3', 'index': 2};
                break;
            case 'CO2':
                sensor =  {"name": "二氧化碳", "value": '', 'union': 'ppm', 'index': 2};
                break;
            case 'O2':
                sensor =  {"name": "氧气", "value": '', 'union': '%', 'index': 2};
                break;
            case 'dqy':
                sensor =  {"name": "大气压力", "value": '', 'union': 'mbar', 'index': 2};
                break;
            case 'kqzl':
                sensor =  {"name": "TVOC2", "value": '', 'union': 'ppb', 'index': 3};
                break;
            case 'yl':
                sensor = {"name": "雨量", "value": '', 'union': 'mm', 'index': 0};
                break;
            case 'rjy':
                sensor = {'name': '溶解氧', 'value': '', 'union': 'mg/L', 'index': 1}
                break;
            case 'ph':
                sensor =  {'name': 'ph', 'value': '', 'union': '', 'index': 1}
                break;
            case 'ad':
                sensor = {'name': '氨氮', 'value': '', 'union': 'ppm', 'index': 1}
                break;
            case 'trsd':
                sensor = {'name': '土壤湿度', 'value': '', 'union': '%RH', 'index': 0};
                break;
            case 'swen':
                sensor = {'name': '水温', 'value': '', 'union': '°C', 'index': 0};
                break;
            case 'ddl':
                sensor = {"name": "电导率", "value": '', 'union': 'us/cm', 'index': 0}
                break;
            case 'll':
                sensor = {'name': '流量', 'value': '', 'union': 'L/h', 'index': 0};
                break;
            case 'trfl':
                sensor = {'name': '土壤肥力', 'value': '', 'union': 'mg/kg', 'index': 0};
                break;
            case 'trzh':
                sensor = {'name': '土壤综合', 'value': '', 'union': 'mg/kg', 'index': 0};
                break;
            case 'hxll':
                sensor = {'name': '和信流量计', 'value': '', 'union': 'L/h', 'index': 0};
                break;
            case 'wlll':
                sensor = {'name': '涡轮流量计', 'value': '', 'union': 'L/h', 'index': 0};
                break;
            case 'wsb0':
                sensor = {"name": "无设备", "value": '', 'union': '暂无数据', 'index': 0};
                break;
        }
        return sensor;
    },
    sensorData(eid, factoryType) {
        var type;
        if (eid.split('-').length > 1) {
            type = eid.split('-')[1];
        } else {
            type = eid;
        }
        var sensor;
        if (factoryType == 6) {
            switch (type) {
                case 'sw':
                    sensor = [{'name': '水位', 'value': '', 'union': 'M', 'index': 0}];
                    break;
                case 'hw':
                    sensor = [{'name': '红外', 'value': '', 'union': '', 'index': 0}];
                    break;
                case 'gzd':
                    sensor = [{'name': '光照度', 'value': '', 'union': 'Lux', 'index': 0}];
                    break;
                case 'zs':
                    sensor = [{'name': '噪声', 'value': '', 'union': 'dB', 'index': 0}];
                    break;
                case 'ws':
                case 'dpws':
                case 'trws':
                    sensor = [
                        {"name": "温度", "value": '', 'union': '°C', 'index': 0},
                        {"name": "湿度", "value": '', 'union': '%RH', 'index': 1}
                    ];
                    break;
                case 'pm2510':
                    sensor = [
                        // {"name": "温度", "value": '', 'union': '°C'},
                        // {"name": "湿度", "value": '', 'union': '%RH'},
                        {"name": "PM2.5", "value": '', 'union': 'ug/m3', 'index': 2},
                        {"name": "PM10", "value": '', 'union': 'ug/m3', 'index': 3}
                    ];
                    break;
                case 'CO2':
                    sensor = [
                        // {"name": "温度", "value": '', 'union': '°C'},
                        // {"name": "湿度", "value": '', 'union': '%RH'},
                        {"name": "二氧化碳", "value": '', 'union': 'ppm', 'index': 2}
                    ];
                    break;
                case 'O2':
                    sensor = [
                        // {"name": "温度", "value": '', 'union': '°C'},
                        // {"name": "湿度", "value": '', 'union': '%RH'},
                        {"name": "氧气", "value": '', 'union': '%', 'index': 2}
                    ];
                    break;
                case 'dqy':
                    sensor = [
                        // {"name": "温度", "value": '', 'union': '°C'},
                        // {"name": "湿度", "value": '', 'union': '%RH'},
                        {"name": "大气压力", "value": '', 'union': 'mbar', 'index': 2}
                    ];
                    break;
                case 'kqzl':
                    sensor = [
                        // {"name": "温度", "value": '', 'union': '°C'},
                        // {"name": "湿度", "value": '', 'union': '%RH'},
                        {"name": "CO2", "value": '', 'union': 'ppm', 'index': 2},
                        {"name": "TVOC2", "value": '', 'union': 'ppb', 'index': 3}
                    ];
                    break;
                case 'yl':
                    sensor = [
                        {"name": "雨量", "value": '', 'union': 'mm', 'index': 0},
                    ];
                    break;
                case 'rjy':
                    sensor = [
                        // {"name": "温度", "value": '', 'union': '°C'},
                        {'name': '溶解氧', 'value': '', 'union': 'mg/L', 'index': 1}];
                    break;
                case 'ph':
                    sensor = [
                        // {"name": "温度", "value": '', 'union': '°C'},
                        {'name': 'ph', 'value': '', 'union': '', 'index': 1}];
                    break;
                case 'ad':
                    sensor = [
                        // {"name": "温度", "value": '', 'union': '°C'},
                        {'name': '氨氮', 'value': '', 'union': 'ppm', 'index': 1}];
                    break;
                case 'trsd':
                    sensor = [
                        {'name': '土壤湿度', 'value': '', 'union': '%RH', 'index': 0}];
                    break;
                case 'swen':
                    sensor = [
                        {'name': '水温', 'value': '', 'union': '°C', 'index': 0}];
                    break;
                case 'ddl':
                    sensor = [
                        {"name": "电导率", "value": '', 'union': 'us/cm', 'index': 0},
                    ];
                    break;
                case 'trfl':
                    sensor = [
                        {"name": "氮", "value": '', 'union': '(mg/kg)', 'index': 0},
                        {"name": "磷", "value": '', 'union': '(mg/kg)', 'index': 1},
                        {"name": "钾", "value": '', 'union': '(mg/kg)', 'index': 2}
                    ];
                    break;
                case 'll':
                    sensor = [
                        {"name": "流量", "value": '', 'union': '(L/h)', 'index': 0},
                        {"name": "总流量", "value": '', 'union': '(L/h)', 'index': 1}
                    ];
                    break;
                case 'hxll':
                case 'wlll':
                    sensor = [
                        {"name": "流量", "value": '', 'union': '(L/h)', 'index': 0}
                    ];
                    break;
                case 'trzh':
                    sensor = [
                        {'name': 'ph', 'value': '', 'union': '', 'index': 0},
                        {"name": "湿度", "value": '', 'union': '%RH', 'index': 1},
                        {"name": "温度", "value": '', 'union': '°C', 'index': 2},
                        {"name": "电导率", "value": '', 'union': 'us/cm', 'index': 3},
                        {"name": "氮", "value": '', 'union': '(mg/kg)', 'index': 4},
                        {"name": "磷", "value": '', 'union': '(mg/kg)', 'index': 5},
                        {"name": "钾", "value": '', 'union': '(mg/kg)', 'index': 6}
                    ];
                    break;
            }
        } else {
            switch (type) {
                case 'sw':
                    sensor = [{'name': '水位', 'value': '', 'union': 'M'}];
                    break;
                case 'sd':
                    sensor = [{'name': '湿度', 'value': '', 'union': '%RH'}];
                    break;
                case 'wd':
                    sensor = [{'name': '温度', 'value': '', 'union': '℃'}];
                    break;
                case 'yf':
                    sensor = [{'name': '盐份', 'value': '', 'union': 'us/cm'}];
                    break;
                case 'rjy':
                    sensor = [{'name': '溶解氧', 'value': '', 'union': 'mg/L'}];
                    break;
                case 'ph':
                    sensor = [{'name': 'ph', 'value': '', 'union': ''}];
                    break;
                case 'hw':
                    sensor = [{'name': '红外', 'value': '', 'union': ''}];
                    break;
                case 'gzd':
                    sensor = [{'name': '光照度', 'value': '', 'union': 'Lux'}];
                    break;
                case 'zs':
                    sensor = [{'name': '噪声', 'value': '', 'union': 'dB'}];
                    break;
                case 'ad':
                    sensor = [{'name': '氨氮', 'value': '', 'union': 'ppm'}];
                    break;
                case 'pm25':
                    sensor = [
                        {"name": "PM2.5", "value": '', 'union': 'ug/m3'}
                    ];
                    break;
                case '24':
                    sensor = [{'name': '水位', 'value': '', 'union': 'M'}];
                    break;
                case '3':
                    sensor = [{'name': '温度', 'value': '', 'union': '℃'}];
                    break;
                case '5':
                case '15':
                    sensor = [
                        {"name": "湿度", "value": '', 'union': '%RH'},
                        {"name": "温度", "value": '', 'union': '°C'}
                    ];
                    break;
                case '4':
                    sensor = [{"name": "湿度", "value": '', 'union': '%RH'},
                        {"name": "温度", "value": '', 'union': '°C'},
                        {"name": "盐度", "value": '', 'union': 'us/cm'}];
                    break;
            }
        }
        return sensor;
    },
    /**
     * ajax 执行 api接口
     * @param api_url   [string]    ：接口地址 如：api.login
     * @param data      [object]    ：接口参数（JSON格式），此参数不传递时默认为空（{}）
     * @param success   [callback]  ：成功回调函数
     * @param error     [callback]  ：失败回调
     * @param loads     [bool]      ：false true 是否开启load加载状态  默认开启 true
     * @param type      [string]    ：传输类型，默认post
     * return null
     */
    ajax: (api_url = "",
           data = {},
           success = null,
           error = null,
           type = "post",
           loads = true,
           fail = null,
           isSign = true,
           isJson = true) => {
        // 调用ajax
        func.axiosRequest(
            Vue.prototype.$api[api_url].url,
            data,
            function (r) {
                if (typeof success == "function") success(r);
            },
            function (r) {
                if (typeof error == "function") error(r);
            },
            loads,
            type,
            Vue.prototype.$api[api_url].description,
            fail,
            isSign,
            isJson
        );
    },

    /**
     * axiosRequest 封装
     * @param url         [string]    ：接口地址
     * @param data        [object]    ：接口参数（JSON格式），此参数不传递时默认为空（{}）
     * @param success     [callback]  ：成功回调函数
     * @param error       [callback]  ：失败回调
     * @param loads       [bool]      ：false true 是否开启load加载状态  默认开启 true
     * @param type        [string]    ：传输类型，默认post
     * @param description [string]    ：接口描述
     * return null
     */
    axiosRequest: function (url = "",
                            data = {},
                            success = null,
                            error = null,
                            loads = true,
                            type = "post",
                            description = "",
                            fail = null,
                            isSign = true,
                            isJson = true) {
        //显示加载动画
        // if (loads === true) func.sp();

        // ========= 签名算法，防止数据篡改 start ========= //
        let sendData, _isSign = isSign === false ? false : true;
        if (_isSign) {
            if (data.length != 0) { //将data数据的空格去除
                for (let i in data) {
                    data[i] = func.trim(data[i]);
                }
            }
            sendData = Object.assign({
                deviceId: hex_md5(parseInt(new Date().getTime() / 1000)),
                registerSource: 4,
                timestamp: new Date().getTime()
            }, data);
            let sign = func.MD5Obj(sendData).toLowerCase();
            sendData.sign = sign;
        } else {
            sendData = data;
        }

        // ========= 签名算法，防止数据篡改 end ========= //

        let config = '';
        if (type == "get") {
            config = {
                params: sendData
            }
        } else {
            config = {
                data: sendData
            }
        }

        //application/x-www-form-urlencoded
        if (!isJson) {
            config = {
                params: sendData
            }
        }

        //发起ajax
        let contentType = isJson === false ? 'application/x-www-form-urlencoded' : 'application/json;charset=utf-8';
        //2019-05-14 zby 非本地接口请求头加custId
        let token = func.getToken();
        let custId = func.getUserInfo('custId');
        console.log(custId);
        Axios.request(Object.assign(config, {
            url: url,
            method: type,
            timeout: 45000,
            headers: url.indexOf(hostName) == 0 ? {
                    'Content-Type': contentType,
                    'X-ZNJG-Token': token,
                    'CUST_ID':custId
                } : {'Content-Type': contentType}
        }))
            .then(function (response) {
                //是否开启 debug
                if (ajax_debug) {
                    console.log('************************ 请求开始 start ************************');
                    console.log(
                        `%c 接口描述：%c ${description} %c`,
                        "background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
                        "background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff",
                        "background:transparent"
                    );
                    console.log(`%c请求URL：%c ${url} %c`, "font-weight:bold", "", "");
                    console.log(
                        `%c请求参数：%c ${JSON.stringify(sendData)} %c`,
                        "font-weight:bold",
                        "",
                        ""
                    );
                    console.log(
                        `%c你的参数：%c ${JSON.stringify(data)} %c`,
                        "font-weight:bold",
                        "",
                        ""
                    );
                    console.log(
                        `%c接口返回：%c ${JSON.stringify(response)} %c`,
                        "font-weight:bold",
                        "",
                        ""
                    );
                }

                if (response.status === 200) {
                    //判断是token否过期
                    if (response.data.code == 301) {
                        func.data.del("userInfo");
                        func.data.del("tzuid");
                        func.data.del("tztokey");
                        //跳转
                        func.dsqOut(function () {
                            router.push({
                                name: "login"
                            });
                        }, 1);
                    }
                    //正常回调
                    if (typeof success == "function") success(response.data);
                } else {
                    //错误回调
                    if (typeof error == "function") error(response.data);

                }

                //隐藏加载动画
                if (loads === true) func.hp();

                if (ajax_debug) console.log('************************ 请求结束 end ************************');

            })
            .catch(function (error) {
                // func.msg('>_<|||  服务器出故障了，请稍候尝试！','error')
                if (ajax_debug) console.log("%c%s", "color: red;", "✘ 错误信息：" + error+JSON.stringify(config));
                //隐藏加载动画
                if (loads === true) func.hp();
                //错误回调
                if (typeof fail == "function") fail(error);
            });
    },
//2019-05-17 zby 时间格式化
    formatDate(date, fmt){
        var date = new Date(date);
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        let o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
        }
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + ''
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
            }
        }
        return fmt
    },
    /**
     * 对象按照字典顺序md5
     * @param data
     * @constructor
     */
    MD5Obj(data) {
        let sdic = Object.keys(data).sort();
        let strSignBefore = "";
        for (let i in sdic) {
            if (data[sdic[i]] != '' && data[sdic[i]] != undefined) {
                strSignBefore += sdic[i] + "=" + data[sdic[i]];
                if (i != sdic.length - 1) {
                    strSignBefore += "&";
                }
            }
        }
        return hex_md5(strSignBefore);
    },

    //md5加密
    md5(data){
        return hex_md5(data);
    },

    //提示信息
    msg: (message = "", type = "success") => {
        if (message != "" && message != undefined) {
            switch (type) {
                case "success":
                    Vue.prototype.$Message.success(message);
                    break;
                case "error":
                    Vue.prototype.$Message.error(message);
                    break;
                case "warning":
                    Vue.prototype.$Message.warning(message);
                    break;
                default:
                    Vue.prototype.$Message.success(message);
                    break;
            }
        }
    },

    //提示信息
    notice: (message, type, title) => {
        if (message != "" && message != undefined) {
            var _type = type || "success";
            var _title = title || "系统提示";
            switch (_type) {
                case "success":
                    Vue.prototype.$Notice.success({
                        title: _title,
                        desc: message
                    });
                    break;
                case "error":
                    Vue.prototype.$Notice.error({
                        title: _title,
                        desc: message
                    });
                    break;
                case "warning":
                    Vue.prototype.$Notice.warning({
                        title: _title,
                        desc: message
                    });
                    break;
                default:
                    Vue.prototype.$Notice.success({
                        title: _title,
                        desc: message
                    });
                    break;
            }
        }
    },

    //显示加载动画
    sp: () => {
        Vue.prototype.$Spin.show();
    },

    //隐藏加载动画
    hp: () => {
        Vue.prototype.$Spin.hide();
    },

    //定时器 setTimeout
    dsqOut: (fn, time = 1) => {
        if (typeof fn == "function") {
            setTimeout(fn, time * 1000);
        }
    },

    //判断是否是json字符串
    isJson: str => {
        if (typeof str === "string") {
            try {
                var obj = JSON.parse(str);
                if (typeof obj === "object" && obj) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                return false;
            }
        }
    },

    //数据存储和处理
    data: {
        //存储信息
        set: (key = "", data = "", type = "cookie", obj = {}) => {
            switch (type) {
                case "cookie":
                    data = func.isJson(data) ? JSON.stringify(data) : data;
                    Cookies.set(key, data, obj);
                    break;
            }
        },


        //获取信息
        get: (key = "", type = "cookie") => {
            let data;
            switch (type) {
                case "cookie":
                    data = Cookies.get(key);
                    break;
            }
            return func.isJson(data) ? JSON.parse(data) : data;
        },

        //移除信息
        del: (key = "", type = "cookie") => {
            switch (type) {
                case "cookie":
                    Cookies.remove(key);
                    break;
            }
        },

        //信息是否存在 return false or true
        isKey: (key = "", type = "cookie") => {
            switch (type) {
                case "cookie":
                    if (func.data.get(key) == undefined || func.data.get(key) == "") {
                        return false;
                    } else {
                        return true;
                    }
            }
        }
    },

    //验证url
    isUrl: str_url => {
        var strRegex = "^((https|http|ftp|rtsp|mms)?://)";
        var re = new RegExp(strRegex);
        if (re.test(str_url)) {
            return true;
        } else {
            return false;
        }
    },

    //判断是否json对象
    isJSON: str => {
        if (typeof str == "string") {
            try {
                var obj = JSON.parse(str);
                if (typeof obj == "object" && obj) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                return false;
            }
        }
    },

    //判断是否登录
    islogin: (field = "userInfo") => {
        if (func.data.isKey(field)) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * 签名
     * @param data 提交的数据
     * @param key 安全密钥
     * @param timestamp 时间戳
     * @returns {string}
     */
    sign: (data, key, timestamp) => {
        var n = null,
            d = {},
            str = "",
            s = "";
        n = Object.keys(data).sort();
        for (var i in n) {
            d[n[i]] = data[n[i]];
        }
        for (var k in d) {
            if (d[k] === "") continue;
            if (str != "") str += "&";
            str += k + "=" + encodeURIComponent(JSON.stringify(d[k]));
        }
        str += "&key=" + key + "&timestamp=" + timestamp;
        s = hex_md5(str).toUpperCase(); // 这儿是进行MD5加密并转大写
        return s;
    },

    /**
     * 获取用户数据
     * @param field string 获取的参数
     * @returns {string}
     */
    getUserInfo: (param, field = "userInfo") => {
        if (func.data.isKey(field)) {
            return func.data.get(field)[param];
        } else {
            return "no-user-info";
        }
    },

    /**
     * 获取token
     * @param field string 获取的参数
     * @returns {string}
     */
    getToken: (field = "userInfo") => {
        if (func.data.isKey(field)) {
            return func.data.get(field)["token"];
        } else {
            return "no-auth";
        }
    },

    /**
     * 获取client_id
     * @param field string 获取的参数
     * @returns {string}
     */
    getClientId: (field = "userInfo") => {
        if (func.data.isKey(field)) {
            return func.data.get(field)["client_id"];
        } else {
            return "no-client";
        }
    },

    // /**
    //  * 判断是否过期
    //  * @param field string 获取的参数
    //  * @returns {string}
    //  */
    // getToken:(field = 'userInfo')=>{
    //   if(func.data.isKey(field)){
    //     return func.data.get(field).token.value;
    //   }else{
    //     return 'no-auth';
    //   }
    // },
};
export default func;
